import { track } from '@/utils/analytics';
import { IconType } from '@/ui-kit/components/icon/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import ConfirmModal from '@/ui-kit/components/modal/confirm';
import NewListingApiService from '@/services/api/serverless/new-listing';
import BaseAction from './base.action';
import { ActionName, ActionTitle } from '../enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';

export default class DeleteAction extends BaseAction {
  name = ActionName.Delete;
  title = ActionTitle.DeleteListing;
  colorScheme = StyleColorSchemeType.Danger;
  icon = IconType.Trash;
  #analyticEvent = null;

  constructor(config) {
    super(config);
    this.#analyticEvent = config.analyticEvent;
  }

  async execute(listing) {
    const isConfirmed = await DeleteAction.#confirmDeletion();
    let isDeleted = false;

    if (isConfirmed) {
      isDeleted = await DeleteAction.#deleteListing(listing);
    }

    this.#trackExecution(listing);
    this.propagateResult(listing, isDeleted);
  }

  static async #deleteListing(listing) {
    try {
      await NewListingApiService.deleteDraftListing(listing.listingId);
      return true;
    } catch {
      return false;
    }
  }

  #trackExecution({ listingId }) {
    track(this.#analyticEvent, { listingId });
  }

  static #confirmDeletion() {
    return ModalService.open({
      component: ConfirmModal,
      data: {
        message: 'Are you sure you want to delete this listing? This action cannot be undone.',
        title: 'Delete Listing?',
        applyButtonTitle: 'Delete Listing',
      },
    });
  }
}
